import React from 'react'

import { useSelector } from 'react-redux'

import { Display } from '../../Display/Display'
import { ShowText } from '../../UI/ShowText/ShowText'

import { selectorZone } from '../../../slices/humidityZone/humidityZoneSelectors'
import { selectorWallsCharacteristics } from '../../../slices/WallsCharacteristics/WallsCharacteristicsSelectors'

// import { useGetParcedCsvData } from '../../../custom-hooks/useGetParcedCsvData';
// import { prepareDataHelper } from '../../../helpers/prepareDataHelper';
import { getObjectKeyByDepthLvl } from '../../../helpers/getObjectKeyByDepthLvl';
import { useGetJsonData } from '../../../custom-hooks/useGetJsonData'

// import { termsOfUse } from '../../../data/termsOfUse'

import './CalcResult.css'

const prepareInfoHelper = (...params) => {
  const infoString = params.map(p => p?.value).join(', ');
  return infoString
}

const prepareResultHelper = (result) => {
  const preparedResult = <p className='calc-result__number'>
    {result}
    <span className='calc-result__units'>мм</span>
  </p>;
  return preparedResult
}

const strToFloatHeler = (str) => {
  if (str) {
    return parseFloat(str.replace(',', '.'))
  }
};

const calculateResult = (R0, thickness, thermalCoeff, brandParams) => {
  // Рассчет результата по формуле res = (R0 - (tw / lw)) * lu
  const res = (R0 - ((strToFloatHeler(thickness.value) / 1000) / strToFloatHeler(thermalCoeff))) * brandParams.thermalConductivity10.value * 1000;
  return res;
}

export const CalcResult = () => {
  const [district, region, locality, _, subject] = useSelector(selectorZone)
  const humidityType = useSelector(state => state.humidityRoom.humidityType);
  const [wallMaterial, density, thickness, thermalCoeff] = useSelector(selectorWallsCharacteristics);
  const brandType = useSelector(state => state.brand.brandType);
  const brandParams = useSelector(state => state.brand.brandParams);

  const subjectPreparedData = useGetJsonData('required-resistance-to-heat-transfer.json');

  const subjectVal = Object.keys(subject)[0]
  const currentSubject = subjectPreparedData ? subjectPreparedData[subjectVal] : undefined;

  const R0 = strToFloatHeler(getObjectKeyByDepthLvl(currentSubject, 1));
  const result = calculateResult(R0, thickness, thermalCoeff, brandParams);

  // округдление расчётной толщины до величины, кратной 10
  const roundedRes = Math.ceil(result/10)*10;
  const resToDisplay = roundedRes > 0 ? roundedRes : 0
  const resultTex = resToDisplay > 0 ? 'Вам необходим теплоизоляционный слой не менее' : 'Нет необходимости в теплоизоляции'

  return (
    <div className='calc-result'>
      <div className="calc-result__specified-data-wrapper">
        <div className="calc-result__specified-data">
          <ShowText 
            label={'Местоположение'} 
            text={prepareInfoHelper(locality, region, district)} 
          />
        </div>
        <div className="calc-result__specified-data">
          <ShowText 
            label={'Влажностный режим помещения'} 
            text={humidityType} 
          />
        </div>
        <div className="calc-result__specified-data">
          <ShowText 
            label={'Характеристики стены'} 
            text={prepareInfoHelper(wallMaterial, density, thickness)} 
          />
        </div>
        <div className="calc-result__specified-data">
          <ShowText 
            label={'Марка фасадного пенополистирола'} 
            text={brandType} 
          />
        </div>
      </div>
      <div className="calc-result__display">
        <Display 
          text={resultTex} 
          className={'calc-result__display-item'}
          displayParam={prepareResultHelper(resToDisplay)}
        />
      </div>
    </div>
  )
}
